import { createColumnHelper } from "@tanstack/react-table";
import { T } from "@tolgee/react";
import type { UserFundingUpdate } from "#/hooks/use-hyperliquid-account";
import { formatDetailedDateTime, formatSignedUsd } from "../../lib/formatters";

const col = createColumnHelper<UserFundingUpdate>();

export const fundingHistoryColumns = [
	col.accessor("time", {
		id: "time",
		header: () => <T keyName="funding.columns.time" />,
		cell: ({ getValue }) => (
			<span className="text-label2-tabular-medium text-trade-text-faint">
				{formatDetailedDateTime(getValue())}
			</span>
		),
	}),
	col.accessor("delta.coin", {
		id: "coin",
		header: () => <T keyName="funding.columns.coin" />,
		enableSorting: false,
		cell: ({ getValue }) => (
			<span className="text-label2-medium text-trade-text-strong">{getValue()}</span>
		),
	}),
	col.accessor("delta.fundingRate", {
		id: "fundingRate",
		header: () => <T keyName="funding.columns.rate" />,
		enableSorting: false,
		cell: ({ getValue }) => {
			const rate = Number(getValue());
			return (
				<span
					className={`text-label2-tabular-medium ${rate >= 0 ? "text-trade-green" : "text-trade-red"}`}
				>
					{(rate * 100).toFixed(4)}%
				</span>
			);
		},
	}),
	col.accessor("delta.szi", {
		id: "positionSize",
		header: () => <T keyName="funding.columns.position" />,
		enableSorting: false,
		cell: ({ getValue, row }) => {
			const szi = Number(getValue());
			return (
				<span
					className={`text-label2-tabular-medium ${szi >= 0 ? "text-trade-green" : "text-trade-red"}`}
				>
					{getValue()} {row.original.delta.coin}
				</span>
			);
		},
	}),
	col.accessor("delta.usdc", {
		id: "payment",
		header: () => <T keyName="funding.columns.payment" />,
		enableSorting: false,
		cell: ({ getValue }) => {
			const usdc = Number(getValue());
			return (
				<span
					className={`text-label2-tabular-medium ${
						usdc === 0
							? "text-trade-text-secondary"
							: usdc > 0
								? "text-trade-green"
								: "text-trade-red"
					}`}
				>
					{formatSignedUsd(usdc)}
				</span>
			);
		},
	}),
];
